import styled from "styled-components";

const CHECKBOX_CONTAINER_SIZE = 16;
const ARROW_SIZE = 16;

export const DeliverySpeedOptinContainer = styled.div`
    background: linear-gradient(90deg, #f7f7f7 0.04%, #f8f8f8 22.59%, #fff 89.19%);
    border-radius: ${(props) => props.theme.cornerRadius.medium};
    height: 44px;
    display: flex;
    align-items: center;
    position: relative;
    margin: ${(props) => `0 ${props.theme.spacing.xxSmall}`};

    &:after {
        content: "";
        position: absolute;
        top: -6px;
        left: calc(15% - ${(props) => props.theme.spacing.xSmall});
        width: ${ARROW_SIZE}px;
        height: ${ARROW_SIZE}px;
        background: #f7f7f7;
        transform: rotate(45deg);
        border-top-left-radius: ${(props) => props.theme.cornerRadius.xxSmall};
    }
`;

export const CheckboxContainer = styled.div.attrs((props: { isOptedIn: boolean }) => props)`
    width: ${CHECKBOX_CONTAINER_SIZE}px;
    height: ${CHECKBOX_CONTAINER_SIZE}px;
    border-radius: ${(props) => props.theme.cornerRadius.xxSmall};
    border: ${(props) => {
        if (props.isOptedIn) {
            return "none";
        }

        return `1.5px solid ${props.theme.colors[props.theme.colorMode].border_Secondary}`;
    }};
    background-color: ${(props) => {
        if (props.isOptedIn) {
            return props.theme.colors[props.theme.colorMode].primary;
        }

        return "transparent";
    }};
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 15px;
    margin-right: 12px;
`;
